import React, { useCallback, useMemo } from 'react';
import { Checkbox, Input } from '@cognitiv/cyprus-ui';
import { ParameterMethodFieldsProps } from 'ducks/types/prop-types';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { useManageParameterContext } from 'modals/parameters/context/ManageParameterContext';
import { getCheckBoxTheme } from 'utils/modal/helpers';

import cn from 'modals/parameters/components/Components.module.scss';

export const ParameterMethodFields = ({ id }: ParameterMethodFieldsProps) => {
  const { theme } = useSwitchTheme();
  const check_box_theme = useMemo(() => getCheckBoxTheme(theme), [theme]);
  const { form, onChange } = useManageParameterContext();

  const onPrefixChange = useCallback((item: string) => onChange({ command_line_prefix: item }), [onChange]);
  const onAssignmentCharacterChange = useCallback(
    (item: string) => onChange({ command_line_assignment_char: item }),
    [onChange],
  );
  const onEscapeValueClick = useCallback((item: boolean) => onChange({ command_line_escaped: item }), [onChange]);
  const onIgnoreNameClick = useCallback((item: boolean) => onChange({ command_line_ignore_name: item }), [onChange]);
  const onRequiredClick = useCallback((item: boolean) => onChange({ is_required: item }), [onChange]);
  const onEncryptedClick = useCallback((item: boolean) => onChange({ is_encrypted: item }), [onChange]);

  const {
    command_line_prefix,
    command_line_assignment_char,
    command_line_escaped,
    command_line_ignore_name,
    is_required,
    is_encrypted,
  } = form;

  return (
    <>
      {id === 1 && (
        <>
          <div className={cn.parameterInputsWrapper}>
            <Input
              value={command_line_prefix ?? ''}
              label="Prefix"
              margin="16px 5px 0px 0px"
              width="calc(50% - 5px)"
              onChange={onPrefixChange}
            />
            <Input
              value={command_line_assignment_char ?? ''}
              label="Assignment Character"
              margin="16px 0px 0px 5px"
              width="calc(50% - 5px)"
              onChange={onAssignmentCharacterChange}
            />
          </div>
          <div className={cn.checkboxWrapper}>
            <Checkbox width={null} onClick={onEscapeValueClick} checked={command_line_escaped} theme={check_box_theme}>
              Escape Value
            </Checkbox>
            <Checkbox
              width={null}
              onClick={onIgnoreNameClick}
              checked={command_line_ignore_name}
              theme={check_box_theme}
            >
              Don't Include Name
            </Checkbox>
            <Checkbox width={null} onClick={onRequiredClick} checked={is_required} theme={check_box_theme}>
              Required
            </Checkbox>
          </div>
        </>
      )}
      {id === 2 && (
        <div className={cn.checkboxWrapper}>
          <Checkbox width={null} onClick={onEncryptedClick} checked={is_encrypted} theme={check_box_theme}>
            Encrypted
          </Checkbox>
        </div>
      )}
    </>
  );
};
